export enum MarriageStatus {
	Married,
	Single,
	Divorced,
	Widowed
}

export const MarriageStatusNames = {
	[MarriageStatus.Married]: 'Married',
	[MarriageStatus.Single]: 'Single',
	[MarriageStatus.Divorced]: 'Divorced',
	[MarriageStatus.Widowed]: 'Widowed',
};
